import React from "react";
import { Sidebar, sidebarClasses } from "react-pro-sidebar";
import SidebarContent from "./SidebarContent";
import { selectCommonData, setShowSideBar } from "../reducers/common.reducer";
import { useDispatch, useSelector } from "react-redux";

function CusSidebar() {
  const { showSideBar } = useSelector(selectCommonData);
  const dispatch = useDispatch();
  return (
    <Sidebar
      onBackdropClick={() => dispatch(setShowSideBar())}
      toggled={showSideBar}
      breakPoint="all"
      transitionDuration={300}
      rootStyles={{
        color: "#fff",
        [`.${sidebarClasses.container}::-webkit-scrollbar `]: {
          display: "none"
        },
      }}
    >
      <SidebarContent />
    </Sidebar>
  );
}

export default CusSidebar;